{
  "fr": {
    "aiChat": {
      "aiAssistant": {
        "explore": {
          "filters": {
            "all": "Points forts",
            "character": "Personas",
            "model": "Modèles de langage IA",
            "plugin": "Plugins",
            "pupils": "Élèves",
            "teachers": "Enseignant·e·s"
          },
          "titles": {
            "administration": "Administration scolaire et organisation",
            "exercises": "Exercices et aides à l'apprentissage",
            "featured": "Assistants populaires",
            "feedback": "Feedback et évaluation",
            "information": "Information et orientation",
            "inspiration": "Inspiration et créativité",
            "material": "Matériel et tâches",
            "model": "Plugins",
            "other": "Autres",
            "planning": "Planification et organisation des cours",
            "roleplay": "Chatbot jeu de rôle"
          }
        },
        "errors": {
          "skillUploadFailed": "Échec du téléversement du skill. Veuillez réessayer.",
          "maxSkillsReached": "Maximum {max} skills par assistant.",
          "skillInUse": "Ce skill est encore utilisé par un assistant et ne peut pas être supprimé.",
          "saveFailed": "Les modifications n'ont pas pu être enregistrées. Veuillez réessayer.",
          "skillContentTooLong": "Le contenu du skill dépasse la longueur maximale de 100 000 caractères.",
          "skillBundleInvalid": "Le pack de compétences est invalide ou contient des chemins de fichiers non sécurisés.",
          "skillBundleMissingSkill": "Le pack de compétences doit contenir un fichier SKILL.md à la racine ou dans un seul dossier parent.",
          "skillBundleTooLarge": "Le pack de compétences ou l'un de ses fichiers dépasse la taille autorisée.",
          "skillBundleTooManyFiles": "Le pack de compétences ne doit pas contenir plus de 200 fichiers."
        },
        "hints": {
          "fileExtractingText": "Texte en cours d'extraction...",
          "fileParsingImages": "Images en cours de traitement : {progress}%",
          "fileIndexingFailed": "Le fichier n'a pas pu être indexé",
          "fileIndexingRunning": "Fichier en cours d'indexation",
          "fileIndexingProgress": "Indexation : {progress}%",
          "fileIndexingSuccessfully": "Fichier indexé avec succès",
          "largeFileUploaded": "Le texte téléchargé est très volumineux et convient bien comme connaissance de fond pour des questions concrètes sur le texte et des tâches de reproduction (AFB I).",
          "maxHandoffsReached": "Maximum {max} assistants de transfert par assistant.",
          "noHandoffAssistants": "Aucun assistant correspondant trouvé.",
          "noSkills": "Aucun skill disponible pour le moment.",
          "skillUploadHint": "Le fichier .md doit contenir les champs name, description et when-to-use dans le YAML frontmatter. Optionnel : allowed-tools.",
          "skillBundleUploadHint": "Formats pris en charge : Markdown (.md) ou un pack de compétences ZIP (.zip). Un pack ZIP doit contenir un fichier SKILL.md à la racine ou dans un seul dossier parent ; les scripts, références et modèles sont facultatifs.",
          "skillDocLink": "En savoir plus"
        },
        "infoMessages": {
          "assistantFiles": "Ici, vous pouvez télécharger des connaissances de fond supplémentaires pour votre assistant, auxquelles il peut accéder lors d'une requête. Notez que votre assistant ne peut pas accéder aux images dans les PDF.",
          "conversationStarters": "Formulez une demande claire au modèle de langage pour accomplir une tâche spécifique. Par exemple : 'Créez-moi un plan de cours.'",
          "enabledTools": "Grâce aux plugins, votre assistant peut appeler divers outils ou générer des images.",
          "handoffAssistants": "Sélectionnez jusqu’à deux assistants auxquels cet assistant peut déléguer du travail pendant une conversation.",
          "skills": "Les skills sont des packs d'instructions réutilisables. Sélectionnez les skills que cet assistant peut charger via l'outil read_skill.",
          "systemPrompt": "Dans l'instruction, vous pouvez formuler la tâche pour votre assistant. Dans le catalogue, vous trouverez l'assistant IA Rob, l'expert en prompts de rôle, qui vous aidera à formuler."
        },
        "labels": {
          "author": "Auteur·e",
          "enabledTools": "Plugins",
          "fobizzSkills": "Skills Fobizz",
          "handoffAssistants": "Assistants de transfert",
          "manageSkills": "Gérer les skills",
          "model": "Modèle",
          "mySkills": "Mes skills",
          "openModels": "Modèles ouverts",
          "otherModels": "Autres modèles",
          "recommendedModels": "Modèles recommandés",
          "remixCount": "Remix",
          "searchSkills": "Rechercher des skills...",
          "skillFileCount": "1 fichier | {count} fichiers",
          "skills": "Skills",
          "systemPrompt": "Rôle et instructions"
        },
        "links": {
          "create": "Créer un assistant",
          "copySkill": "Copier dans le presse-papiers",
          "downloadSkill": "Télécharger le skill",
          "removeSkill": "Supprimer le skill",
          "uploadSkill": "Téléverser un skill"
        },
        "buttons": {
          "removeSkill": "Supprimer le skill"
        },
        "paragraphs": {
          "alert": "Que ce soit pour vous ou vos élèves, votre propre assistant est axé sur un domaine d'application spécifique. Vous pouvez par exemple télécharger des documents comme des images ou des articles de journaux et poser des tâches ciblées.",
          "alertPupil": "Votre propre assistant est axé sur un domaine d'application spécifique. Vous pouvez par exemple télécharger des documents comme des images ou des articles de journaux et poser des tâches ciblées."
        },
        "placeholders": {
          "conversationStarter": "Entrez une question ou une demande suggérée...",
          "description": "Courte explication pour les utilisateur·rice·s de ce que votre assistant peut faire...",
          "searchHandoffAssistants": "Rechercher des assistants pour le transfert...",
          "systemPrompt": "Définissez ici précisément comment votre assistant doit se comporter dans quelles situations, quels plugins et sources il ou elle doit préférer utiliser dans quels cas et quel rôle il ou elle doit jouer dans le chat."
        },
        "titles": {
          "alert": "Ici, vous pouvez facilement créer votre propre assistant",
          "community": "Découvrez les assistants IA pour votre quotidien scolaire",
          "create": "Créez et partagez vos propres assistants"
        },
        "tooltips": {
          "clickToUploadAvatar": "Cliquez ou glissez une image ici",
          "generateAvatar": "Générer une image",
          "generateConversationStarter": "Générer une suggestion de démarrage de chat",
          "generateConversationStarterDisabled": "Remplissez le nom et la description pour générer un démarrage de chat",
          "generatePrompt": "Générer une instruction",
          "adminOnly": "Visible uniquement pour les admins 🤓",
          "generatePromptDisabled": "Remplissez le nom et la description pour générer une instruction",
          "remixNotAllowed": "Le remix n'est pas autorisé pour cet assistant."
        }
      },
      "confirm": {
        "deleteAssistant": {
          "text": "L'assistant sera retiré de votre aperçu. Vous le retrouverez ensuite dans la corbeille.",
          "title": "Supprimer l'assistant ?"
        },
        "deleteChat": {
          "text": "Cette action est irréversible. Le chat {modelName} sera définitivement supprimé avec tous ses messages.",
          "title": "Supprimer le chat ?"
        }
      },
      "conversationGroups": {
        "last30Days": "Les 30 derniers jours",
        "last7Days": "Les 7 derniers jours",
        "older": "Plus ancien",
        "today": "Aujourd'hui",
        "yesterday": "Hier"
      },
      "conversationStartersDefault": {
        "prompt1": "Créez un brainstorming avec cinq idées créatives pour introduire le thème de la « résistance électrique » en physique pour une classe de 9e.",
        "prompt2": "Élaborez trois questions d'examen ouvertes sur l'analyse des personnages de « La Visite de la vieille dame » pour un cours d'allemand de 11e année dans une école polyvalente.",
        "prompt3": "Rédigez une invitation à une rencontre parents-enseignant le 25 septembre à 18 h 30.",
        "prompt4": "Créez un plan de cours sous forme de tableau pour une séance de mathématiques de 90 minutes en 8e année sur le thème du « théorème de Pythagore »."
      },
      "conversationStartersStudents": {
        "prompt1": "Explique-moi comment résoudre cette tâche : \"Écrire une interprétation de poème\"",
        "prompt2": "Peux-tu m'expliquer ce qu'est la \"mitose\" ?",
        "prompt3": "Je dois faire un exposé sur l'Union européenne. Aide-moi à trouver un sujet.",
        "prompt4": "Aide-moi à me préparer pour un contrôle de politique sur le \"Brexit\"."
      },
      "errors": {
        "conversationCreateFailed": "Erreur lors de la création de la conversation. Veuillez réessayer.",
        "fileAlreadyExists": "Fichier '{filename}' déjà téléchargé",
        "fileRemoveFailed": "Erreur lors de la suppression du fichier",
        "fileUploadFailed": "Erreur lors du téléchargement de '{filename}'",
        "maxFilesReached": "Maximum {max} fichiers autorisés",
        "visionNotSupportedDescription": "Veuillez changer de modèle ou supprimer l'image.",
        "visionNotSupportedTitle": "Le modèle sélectionné ne prend pas en charge les images."
      },
      "form": {
        "avatar": "À quoi ressemble votre assistant ?",
        "fileLimit": "(max. {maxFiles} fichiers, chacun max. {size} MB, total max. {totalSize} MB)",
        "files": "Votre assistant a-t-il des informations de fond spéciales ?",
        "imageHint": "Créez une image de prévisualisation générée par IA ou {uploadLink}.",
        "knowledge": "Qui est votre assistant et que peut-il faire ?",
        "title": "Créer un assistant",
        "upload": "Télécharger des connaissances de fond",
        "uploadLinkText": "téléchargez votre propre image"
      },
      "headers": {
        "editConversation": "Renommer la conversation"
      },
      "help": {
        "scrollToBottom": "Faire défiler vers le bas",
        "scrollToTop": "Faire défiler vers le haut",
        "startSpeech": "Lire la réponse",
        "stopSpeech": "Arrêter la lecture",
        "switchGoogleAccount": "Changer de compte Google",
        "uploadFileDescription": "Formats acceptés : PDF, Word, PowerPoint, Excel, CSV. Important : veillez à ce que les fichiers ne contiennent aucune donnée personnelle.",
        "uploadGoogleDrive": "Connectez-vous à Google Drive",
        "uploadImageDescription": "Posez des questions sur cette image, faites-la analyser ou transcrire le contenu textuel. Important : veillez à ce que les images ne contiennent aucune donnée personnelle.",
        "voiceMode": "Mode vocal interactif 🤓",
        "voiceRecorder": "Commencez l'enregistrement audio et prononcez le prompt.",
        "documentExport": "Découvrez ici de nouvelles fonctions d'exportation",
        "exportHint": "Découvrez ici de nouvelles options d'exportation, par exemple en PDF, PowerPoint ou fichier Word."
      },
      "hints": {
        "cancelled": "Réponse annulée.",
        "chatPrompt": "Ne partagez jamais de données personnelles avec l'IA et vérifiez les réponses de manière critique.",
        "chatPromptTooltip": "En savoir plus sur la protection des données active",
        "emptyConversationPdf": "Cet historique de chat est vide.",
        "emptyConversationPdfTitle": "Télécharger la conversation du chat IA",
        "emptyConversationPdfAlt": "Illustration d'une conversation de chat vide",
        "fileUpload": "Ajouter du matériel",
        "fileUploadLimitReached": "Vous avez atteint la limite de téléchargement pour les fichiers et images. Supprimez un fichier pour en ajouter un nouveau.",
        "flagged": "Ce message a été rejeté en raison de filtres de contenu. Veuillez essayer avec un autre prompt",
        "noSearchResults": "Nous n'avons malheureusement pas pu trouver de chat avec ce terme.",
        "perplexityNote": "Les réponses de ce chatbot IA sont basées sur une recherche Web effectuée par Perplexity. Gardez à l'esprit que les résultats sont basés sur des contenus Web et doivent donc être vérifiés de manière critique. Utilisez la recherche Web pour poser vos questions et vérifiez soigneusement les sources.",
        "remixableHint": "D'autres personnes peuvent copier votre assistant et l'utiliser comme base pour leurs propres assistants.",
        "selectSystemHint": "Paramètres et outils"
      },
      "labels": {
        "allCitationsWithCount": "Toutes les sources ({count})",
        "category": "Catégorie",
        "conversationStarter": "Démarreur de chat",
        "conversationStarters": "Démarreur de chat",
        "createdWithModel": "Créé avec {model}",
        "experimental": "Aperçu",
        "featured": "Nouveau drapeau",
        "remixable": "Autoriser le remix",
        "fobizzAi": "fobizz IA",
        "imageModel": "Générateur d'images",
        "international": "Langue :",
        "maxDailyMessagesCount": "Limite quotidienne",
        "model": "Modèle de langage",
        "newConversation": "Nouvelle conversation",
        "remixAssistantFiles": "Les documents peuvent être réutilisés lors du remix.",
        "removeSystemHint": "Supprimer l'avis système",
        "selectModel": "Sélectionner un modèle de langage",
        "modelSelectionGuide": "Quel modèle de langage convient à votre assistant ?",
        "modelSelectionLink": "Vers l'aperçu",
        "pupilRestrictedModelWarning": "Ce modèle est réservé aux enseignant·e·s. Les élèves utilisent automatiquement un autre modèle par défaut.",
        "selectSystemHint": "Choisir un avis système",
        "showAllCitations": "Afficher toutes les sources",
        "subcategory": "Sous-catégorie",
        "thinking": "Réfléchir",
        "handoff": "Transfert",
        "viewImage": "Voir l'image",
        "message": "Message de {author}"
      },
      "toolApproval": {
        "approve": "Autoriser",
        "reject": "Refuser",
        "approved": "Autorisé",
        "rejected": "Refusé",
        "error": "La décision n’a pas pu être enregistrée. Veuillez réessayer."
      },
      "links": {
        "connectGoogleDrive": "Google Drive 🤓",
        "explore": "Catalogue d'assistants IA",
        "helpModelCards": "Aide à la décision modèles de langage",
        "moreModels": "Plus de modèles",
        "myAssistants": "Mes assistants",
        "removeFile": "Supprimer le fichier",
        "removeMaterial": "Supprimer le matériel",
        "startChat": "Démarrer le chat",
        "switchGoogleAccount": "Changer de compte",
        "uploadFile": "Télécharger un fichier",
        "uploadGoogleDrive": "Sélectionner un fichier",
        "uploadImage": "Télécharger une image"
      },
      "modelDescriptions": {
        "0": "Choisit automatiquement un modèle adapté à votre demande",
        "1": "Pour des réponses rapides et des dialogues simples",
        "2": "Pour des tâches à plusieurs étapes et des problèmes complexes"
      },
      "placeholders": {
        "promptInputDefault": "Que puis-je faire pour vous aujourd'hui ?",
        "assistantDeleted": "L'assistant a été supprimé — cette conversation est en lecture seule.",
        "searchAssistants": "De quoi avez-vous besoin d'aide ?",
        "searchChats": "Rechercher dans les chats...",
        "searchMyAssistants": "Rechercher des assistants..."
      },
      "privacyProtectionModal": {
        "description": "Vos entrées et conversations sont privées, anonymisées par fobizz et non utilisées pour entraîner des modèles IA.",
        "learnMore": "En savoir plus",
        "learnMoreUrl": "https://app.fobizz.com/de/help/categories/63-datenschutz-recht",
        "title": "Protection des données active"
      },
      "promptLibraryModal": {
        "description": "Notre collection de prompts contient de nombreuses idées utiles. Choisissez un prompt et complétez-le avec vos propres infos.",
        "header": "Bibliothèque de prompts",
        "submitPromptHtml": "Soumettre votre propre suggestion de prompt : <a href=\"https://app.fobizz.com/surveys/surveys/f7d293df-e9d9-4fdf-b47c-df0d79221942/public_survey_responses/new?token=ed4073db9ac22c8bcbcc65727711eb0e\"  target=\"_blank\">Vers le formulaire</a>"
      },
      "studentPromptLibrary": {
        "examPrep": {
          "prompts": [
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            }
          ],
          "title": "Préparation aux examens"
        },
        "jobApplication": {
          "prompts": [
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            }
          ],
          "title": "Entraînement à la candidature"
        },
        "learningAssistance": {
          "prompts": [
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            }
          ],
          "title": "Aide à l'apprentissage"
        },
        "writingAssistance": {
          "prompts": [
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            }
          ],
          "title": "Aide à l'écriture"
        }
      },
      "success": {
        "fileRemoved": "'{filename}' supprimé avec succès",
        "fileUploaded": "'{filename}' téléchargé avec succès",
        "skillCopied": "Skill copié dans le presse-papiers",
        "skillRemoved": "Skill supprimé avec succès"
      },
      "systemPrompt": "Vous êtes un assistant utile et amical. Si vous ne connaissez pas une réponse, dites : \"Je ne sais pas.\" Demandez plus d'infos si nécessaire pour bien répondre à ma demande. Répondez toujours dans la langue dans laquelle vous êtes abordé.",
      "systemPromptLibrary": {
        "careerCounseling": {
          "prompts": [
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            }
          ],
          "title": "Orientation professionnelle"
        },
        "experts": {
          "prompts": [
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            }
          ],
          "title": "Expert·e·s"
        },
        "languageAndWritingCoaches": {
          "prompts": [
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            },
            {
              "title": "",
              "prompt": ""
            }
          ],
          "title": "Aide à l'écriture et à la langue"
        }
      },
      "systemPromptModal": {
        "editLabel": "Modifier la description du rôle",
        "heading": "Adapter le rôle du chat IA",
        "useSystemPromptLibrary": "ou choisir dans la collection de rôles"
      },
      "takeNote": {
        "bullet1": "Parfois, je donne des réponses qui semblent plausibles mais qui sont incorrectes ou inventées.",
        "bullet2": "Mes connaissances s'arrêtent à 2023 - je n'ai (encore) aucune idée de ce qui s'est passé après.",
        "heading": "À noter"
      },
      "teaserItem": {
        "linkName": "Découvrir les formations",
        "title": "Voulez-vous en savoir plus sur les assistants IA ?",
        "url": "https://app.fobizz.com/fortbildungen?search%5Bquery%5D=KI-Assistenten"
      },
      "teaserItem2": {
        "linkName": "Soumettre une idée",
        "title": "Avez-vous un assistant qui devrait apparaître ici ?",
        "url": "https://app.fobizz.com/surveys/surveys/fa37a4ba-38ba-4ef2-9c99-022e9e551492/public_survey_responses/new?token=4ed09ebc3b212a3886fd53193eee4746"
      },
      "teaserItem3": {
        "linkName": "Plus d'informations dans la section d'aide",
        "title": "Besoin d'aide pour choisir un modèle ?",
        "url": "https://app.fobizz.com/de/help/articles/426-wahl-des-sprachmodells"
      },
      "tips": {
        "bullet1": "Mes réponses sont parfaites comme premier brouillon, mais rarement comme résultat final.",
        "bullet2": "Si vous n'êtes pas satisfait de ma réponse, reformulez-la de manière plus précise.",
        "heading": "Conseils pour vous"
      }
    }
  }
}
